import { Injectable } from '@angular/core';
import { CustomerdetailsOpenOrder } from "./customerdetailsData";
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Http } from '@angular/http';
import {ProductService} from "../providers/products.service";
import {Totalamount} from "../providers/list-of-customers";
@Injectable()
export class CustomerDetailsService {
    customerDetailsData = [];
    constructor(private cookieService: CookieService, public router: Router, 
        private http:Http, private productService: ProductService) {
    }

    customerDetailsOpenOrder = [];
    custd: number;
    cartListtotal = [];
    productData = [];
    customersData = [];
   // customerDetailsOpenOrder = [];
   // custd:number;
    cartListData = this.productService.selectedItems;
   // cartListtotal = [];
    // productData = [];
    CustomerDetailsService() {
    }

    //    loadCustomersDetails(customerNumber:string){
    //       //this.custd = id;

    //        //this.customerDetailsData[0] = CustomerList[1];     
    //        //return this.customerDetailsData;

    //     //    this.customerDetailsData = this.customerService.selectedcustomer;
    //     //    this.cookieService.set('data',JSON.stringify(this.customerDetailsData));

    //            this.customersData = this.customerService.loadCustomers();
    //            let data = this.customersData.find(ob => ob.customerNumber===customerNumber);



    //  //   return this.studentsData.filter(ob => ob.id === Number)[0];  
    //      //  this.router.navigate(['customerdetails']);   
    //        return data;


    //    }

    init() {

        let cookieValue = this.cookieService.get('data');
        if (cookieValue != "") {

            this.customerDetailsData = JSON.parse(cookieValue);
        }
        return this.customerDetailsData;
    }

    loadCustomersDetails(id):any {

        this.getJson().subscribe(response => {
            let customerDetails = response.json().response.data.customers[1];
            return customerDetails;

        });
    }

    getJson() {
        return Observable.create((observer: Observer<any>) => {
            this.http.get('assets/customersyncapi.json').subscribe(data => {
                observer.next(data);
            });
        });
    }

    loadOpenOrderDetails() {
        this.customerDetailsOpenOrder = CustomerdetailsOpenOrder;
        return this.customerDetailsOpenOrder;

    }
    loadcartListData() {
         this.cartListData = this.productService.selectedItems;
          return this.cartListData;
    }
    loadcartListtotal(){
        this.cartListtotal = Totalamount;
        return this.cartListtotal;
    }
    removeItem(id:number): void {
        let item = this.cartListData.find(ob => ob.id===id);
        let itemIndex = this.cartListData.indexOf(item);
        this.cartListData.splice(itemIndex, 1);
     }
    loadProduct() {
         // this.productData = ProductsData;
         return this.productData;
    }

}




// WEBPACK FOOTER //
// ./src/app/Customerdashboard/customerdetails.service.ts